// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BBiPOmtnU1YCTW6NZMY1{display:flex;column-gap:10px}.BBiPOmtnU1YCTW6NZMY1 button{flex:1}`, "",{"version":3,"sources":["webpack://./ui-kit/Modals/ConfirmModal/ConfirmModal.module.scss"],"names":[],"mappings":"AAEE,sBACE,YAAA,CACA,eAAA,CAEA,6BACE,MAAA","sourcesContent":["@import \"../../../assets/scss/variables\";\r\n\r\n  .ConfirmModalButtons {\r\n    display: flex;\r\n    column-gap: 10px;\r\n\r\n    button {\r\n      flex: 1\r\n    }\r\n  }\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ConfirmModalButtons": `BBiPOmtnU1YCTW6NZMY1`
};
export default ___CSS_LOADER_EXPORT___;
